
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

import Sidebar from "./Sidebar";
import "./Layout.css";

const Layout = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    // Close the mobile sidebar after navigating to another page.
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location.pathname]);

    // Close the sidebar using the Escape key.
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setMobileMenuOpen(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    // Prevent background scrolling when the mobile drawer is open.
    useEffect(() => {
        document.body.style.overflow = mobileMenuOpen ? "hidden" : "";

        return () => {
            document.body.style.overflow = "";
        };
    }, [mobileMenuOpen]);

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <div className="erp-layout">

            {/* MOBILE BACKDROP */}
            {mobileMenuOpen && (
                <button
                    type="button"
                    className="sidebar-backdrop"
                    aria-label="Close navigation menu"
                    onClick={closeMobileMenu}
                />
            )}

            {/* SIDEBAR */}
            <div
                id="erp-navigation"
                className={`sidebar-drawer ${
                    mobileMenuOpen ? "mobile-open" : ""
                }`}
            >
                <Sidebar
                    onNavigate={closeMobileMenu}
                    onClose={closeMobileMenu}
                />
            </div>

            {/* MAIN CONTENT */}
            <main className="erp-main">

                {/* MOBILE NAVBAR */}
                <div className="mobile-menu-bar">
                    <button
                        type="button"
                        className="mobile-menu-button"
                        onClick={() =>
                            setMobileMenuOpen((previous) => !previous)
                        }
                        aria-label={
                            mobileMenuOpen
                                ? "Close navigation menu"
                                : "Open navigation menu"
                        }
                        aria-expanded={mobileMenuOpen}
                        aria-controls="erp-navigation"
                    >
                        {mobileMenuOpen
                            ? <X size={24} aria-hidden="true" />
                            : <Menu size={24} aria-hidden="true" />}
                    </button>

                    <div className="mobile-menu-title">
                        Bhimashankar Agro ERP
                    </div>
                </div>

                {/* COMPANY HEADER */}
                <header className="erp-header">

                    <div className="erp-header-left">
                        <h1>
                            Bhimashankar Agro Coldchain &amp; Processing
                            Producer Co. Ltd.
                        </h1>

                        <p>
                            Cold Storage Management System
                        </p>
                    </div>

                    <div className="header-right">
                        <div className="header-info">
                            <span>
                                Storage Capacity
                            </span>

                            <strong>
                                6000 Tons
                            </strong>
                        </div>
                    </div>

                </header>

                {/* PAGE CONTENT */}
                <section className="erp-content">
                    <Outlet />
                </section>

            </main>
        </div>
    );
};

export default Layout;
